import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import axiosPrivate from "../../../../hooks/axiosPrivate";
import { showErrorToast, showSuccessToast } from "../../../../Toster";
import LoaderContext from "../../../../context/Loader/LoaderContext";
import { useContext } from "react";
import "./submit.css";
import CustomButton from "../../../custom-button";

function UserAddressForm({ getData, sendData, billtype }) {
  const [showCompany, setShowCompany] = useState("");
  const { setLoaderCheck } = useContext(LoaderContext);

  const initialValues = {
    name: "",
    mobile: "",
    email: "",
    address: "",
    landmark: "",
    city: "",
    state: "",
    pincode: "",
    bill_type: "",
    company: "",
    country: "India",
    gst: "",
  };

  const addressSchema = Yup.object({
    name: Yup.string().required("Please enter your name").min(4),
    mobile: Yup.string()
      .test(
        "starts-not-with-0-to-5",
        "Please enter a valid mobile number",
        function (value) {
          // Check if the mobile number does not start from 0 to 5
          if (!value) return true; // If no value, let Yup.string().required handle it
          return !/^[0-5]/.test(value);
        }
      )
      .required("Please enter your mobile number"),
    email: Yup.string()
      .matches(
        /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/,
        "Please enter a valid Email!"
      )
      .required("Please enter your email address"),
    city: Yup.string().required("Please enter City name"),
    state: Yup.string().required("Please enter State name"),
    bill_type: Yup.string().required("Please select address type"),
    address: Yup.string().required("Please enter Address"),
    // city: Yup.string().required('Please enter your city'),
    pincode: Yup.string()
      .required("Please enter your pincode")
      .matches(/^[0-9]{6}$/, "Pincode is not valid"),
    state: Yup.string().required("Please select your state"),
    country: Yup.string().required("Please select your country"),
  });

  const [countryOptions, setCountryOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);

  const fetchCountries = async () => {
    try {
      const response = await axiosPrivate.get("/getCountry");
      const options = response.data.data.map((item) => ({
        label: item.name,
        value: item.name,
      }));
      setCountryOptions(options);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchStates = async (countryName) => {
    if (!countryName) return;
    try {
      const response = await axiosPrivate.get(`/getStates/${countryName}`);
      const options = response.data.data.map((item) => ({
        label: item.name,
        value: item.name,
      }));
      setStateOptions(options);
    } catch (error) {
      console.error(error);
      setStateOptions([]);
    }
  };

  useEffect(() => {
    fetchCountries();
  }, []);

  useEffect(() => {
    if (getData && Object.keys(getData).length > 0) {
      setValues(getData);
    }
  }, [getData]);

  const {
    values,
    errors,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    setValues,
    touched,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: addressSchema,
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (values) => {
      let formData = {
        name: values.name,
        mobile: values.mobile,
        email: values.email,
        address: values.address,
        landmark: values.landmark,
        city: values.city,
        state: values.state,
        pincode: values.pincode,
        bill_type: values.bill_type,
        company: values.company,
        country: values.country,
        gst: values.gst,
      };

      if (Object.keys(getData).length > 0) {
        setLoaderCheck(true);
        axiosPrivate
          .put(`/user-addresses/update/${getData.id}`, formData)
          .then((res) => {
            setLoaderCheck(false);
            sendData(res?.data?.data || res?.data);
            showSuccessToast("Address updated successfully");
          })
          .catch((error) => {
            setLoaderCheck(false);
            if (typeof error.response.data.errors == "array") {
              showErrorToast(error.response.data.errors[0]?.msg);
            } else {
              showErrorToast(error.response.data.errors?.msg);
            }
          });
      } else {
        setLoaderCheck(true);
        axiosPrivate
          .post(`user-addresses/create`, formData)
          .then((response) => {
            setLoaderCheck(false);
            sendData(response?.data?.data || response?.data);
            showSuccessToast("Address added successfully");
          })
          .catch((error) => {
            console.log("error", error);

            setLoaderCheck(false);
            showErrorToast(error.response.data?.message || error.response.data?.errors || "Address already exists");
            if (typeof error.response.data.errors == "array") {
              showErrorToast(error.response.data.errors[0]?.msg);
            } else {
              showErrorToast(error.response.data.errors?.msg);
            }
          });
      }
    },
  });
  useEffect(() => {
    if (billtype) {
      setFieldValue("bill_type", billtype);
      setShowCompany(billtype);
    }
  }, [billtype]);
  useEffect(() => {
    if (values.country) {
      setStateOptions([]);
      fetchStates(values.country);
    } else {
      setStateOptions([]);
    }
  }, [values.country]);

  const companyVisible = (event) => {
    setShowCompany(event.target.value);
  };

  const numberFilter = (event) => {
    const inputValue = event.target.value;

    const numericValue = inputValue.replace(/\D/g, "");
    setFieldValue(event.target.name, numericValue);
  };
  return (
    <div className="modal-content" style={{ border: "none" }}>
      <form className="formWrapper" onSubmit={handleSubmit}>
        <div className="formWrapperContent">
          <div className="formWrapperRow">
            <div className="formWrapperCol">
              <label className="formWrapperLabel" htmlFor="name">
                Name<span className="formWrapperError">*</span>
              </label>
              <input
                type="text"
                name="name"
                value={values?.name}
                id="name"
                className="formWrapperInput"
                placeholder="Enter Name"
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {errors.name || touched.name ? (
                <p className="formWrapperError">{errors.name}</p>
              ) : null}
            </div>
            <div className="formWrapperCol">
              <label className="formWrapperLabel" htmlFor="mobile">
                Mobile Number<span className="formWrapperError">*</span>
              </label>
              <input
                type="text"
                name="mobile"
                value={values?.mobile}
                id="mobile"
                className="formWrapperInput"
                placeholder="Mobile"
                onChange={numberFilter}
                onBlur={handleBlur}
                maxLength={10}
              />
              {errors.mobile || touched.mobile ? (
                <p className="formWrapperError">{errors.mobile}</p>
              ) : null}
            </div>
          </div>
          <div className="formWrapperRow">
            <div className="formWrapperCol">
              <label className="formWrapperLabel" htmlFor="email1">
                Email<span className="formWrapperError">*</span>
              </label>
              <input
                type="email"
                name="email"
                value={values?.email}
                id="email1"
                className="formWrapperInput"
                placeholder="Email"
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {errors.email || touched.email ? (
                <p className="formWrapperError">{errors.email}</p>
              ) : null}
            </div>
            {showCompany === "billing" && (
              <div className="formWrapperCol">
                <label className="formWrapperLabel" htmlFor="gst">
                  GST
                </label>
                <input
                  type="text"
                  name="gst"
                  id="gst"
                  value={values?.gst}
                  className="formWrapperInput"
                  placeholder="GST Number"
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {errors.gst || touched.gst ? (
                  <p className="formWrapperError">{errors.gst}</p>
                ) : null}
              </div>
            )}
            {showCompany !== "billing" && <div className="formWrapperCol"></div>}
          </div>

          <div className="formWrapperRow">
            <div className="formWrapperCol" style={{ width: "100%", maxWidth: "100%", flex: "0 0 100%" }}>
              <label className="formWrapperLabel" htmlFor="address">
                Address<span className="formWrapperError">*</span>
              </label>
              <input
                type="text"
                name="address"
                id="address"
                value={values?.address}
                className="formWrapperInput"
                placeholder="Address"
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {errors.address || touched.address ? (
                <p className="formWrapperError">{errors.address}</p>
              ) : null}
            </div>
          </div>

          <div className="formWrapperRow">
            <div className="formWrapperCol">
              <label className="formWrapperLabel" htmlFor="country">
                Country<span className="formWrapperError">*</span>
              </label>
              <select
                className="formWrapperSelect"
                id="country"
                name="country"
                value={values?.country}
                onChange={(e) => {
                  handleChange(e);
                  setFieldValue("state", ""); // Reset state when country changes
                }}
                onBlur={handleBlur}
              >
                <option value="" disabled>Select Country</option>
                {countryOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              {errors.country || touched.country ? (
                <p className="formWrapperError">{errors.country}</p>
              ) : null}
            </div>
            <div className="formWrapperCol">
              <label className="formWrapperLabel" htmlFor="state">
                State<span className="formWrapperError">*</span>
              </label>
              <select
                className="formWrapperSelect"
                name="state"
                id="state"
                value={values?.state}
                onChange={handleChange}
                onBlur={handleBlur}
              >
                <option value="" disabled>Select State</option>
                {stateOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              {errors.state || touched.state ? (
                <p className="formWrapperError">{errors.state}</p>
              ) : null}
            </div>
          </div>

          <div className="formWrapperRow">
            <div className="formWrapperCol">
              <label className="formWrapperLabel" htmlFor="city">
                City<span className="formWrapperError">*</span>
              </label>
              <input
                type="text"
                name="city"
                id="city"
                value={values?.city}
                className="formWrapperInput"
                placeholder="City Name"
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {errors.city || touched.city ? (
                <p className="formWrapperError">{errors.city}</p>
              ) : null}
            </div>
            <div className="formWrapperCol">
              <label className="formWrapperLabel" htmlFor="pincode">
                Pincode<span className="formWrapperError">*</span>
              </label>
              <input
                type="text"
                name="pincode"
                id="pincode"
                value={values?.pincode}
                className="formWrapperInput"
                placeholder="Enter Pincode"
                onChange={numberFilter}
                onBlur={handleBlur}
                maxLength={6}
              />
              {errors.pincode || touched.pincode ? (
                <p className="formWrapperError">{errors.pincode}</p>
              ) : null}
            </div>
          </div>

          <div className="formWrapperRow">
            {!billtype && (
              <div className="formWrapperCol">
                <label>
                  Address Type:
                  <span className="formWrapperError">*</span>
                </label>

                <div className="">
                  <select
                    className="formWrapperSelect"
                    id="bill_type"
                    name="bill_type"
                    disabled={!!billtype}
                    onChange={(event) => {
                      handleChange(event);
                      companyVisible(event);
                    }}
                    onBlur={handleBlur}
                    value={values.bill_type}
                  >
                    <option disabled selected value="">
                      Select Address Type
                    </option>
                    <option value={"shipping"}>Shipping Address</option>
                    <option value={"billing"}>Billing Address</option>
                  </select>
                  {errors.bill_type || touched.bill_type ? (
                    <p className="formWrapperError">{errors.bill_type}</p>
                  ) : null}
                </div>
              </div>
            )}
            {showCompany === "shipping" && (
              <div className="formWrapperCol">
                <label className="formWrapperLabel" htmlFor="company">
                  Company Name
                </label>
                <input
                  type="text"
                  name="company"
                  id="company"
                  value={values?.company}
                  className="formWrapperInput"
                  placeholder="Enter Company Name"
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {errors.company || touched.company ? (
                  <p className="formWrapperError">{errors.company}</p>
                ) : null}
              </div>
            )}
            {showCompany !== "shipping" && (
              <div className="formWrapperCol"></div>
            )}
          </div>
        </div>
        <div className="formWrapperFooter">
          <CustomButton text={"Submit"} type="submit" className="mb-0" />
        </div>
      </form>
    </div>
  );
}

export default React.memo(UserAddressForm) || UserAddressForm;
